export default __webpack_public_path__ + "static/media/resume.b55911ed.pdf";